var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9397 1.5415C7.16284 1.6265 4.95709 1.98775 3.44975 3.48942C2.12942 4.80409 1.68884 6.65284 1.5415 9.6165M19.06 1.5415C22.8368 1.6265 25.0426 1.98775 26.5499 3.48942C27.8703 4.80409 28.3108 6.65284 28.4582 9.6165M19.06 28.4582C22.8368 28.3732 25.0426 28.0119 26.5499 26.5103C27.8703 25.1956 28.3108 23.3468 28.4582 20.3832M10.9397 28.4582C7.16284 28.3732 4.95709 28.0119 3.44975 26.5103C2.12942 25.1956 1.68884 23.3468 1.5415 20.3832M8.62484 22.0832C11.9285 18.6237 18.0358 18.4608 21.3748 22.0832M18.5344 11.4582C18.5344 13.4132 16.9478 14.9998 14.9885 14.9998C14.5229 15.0006 14.0618 14.9095 13.6314 14.7319C13.2011 14.5542 12.81 14.2935 12.4805 13.9645C12.151 13.6356 11.8896 13.2449 11.7113 12.8148C11.533 12.3848 11.4412 11.9237 11.4412 11.4582C11.4412 9.50317 13.0278 7.9165 14.9885 7.9165C15.454 7.91595 15.915 8.00714 16.3451 8.18488C16.7753 8.36261 17.1663 8.6234 17.4956 8.95233C17.8249 9.28126 18.0862 9.67188 18.2644 10.1019C18.4427 10.5318 18.5344 10.9927 18.5344 11.4582Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.5408d0ecfe65297e6090b0f6a5846afa.svg";
export { ForwardRef as ReactComponent };